import b64toBlob from "./b64toBlob";

const getFileURL = (data, fileType) => {
  const file = new Blob([data], {
    type: fileType,
  });
  return URL.createObjectURL(file);
};

const readFileAsync = (file) => {
  return new Promise(async (resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = () =>
      reject("An error occurred while trying to read the file");

    reader.readAsArrayBuffer(file);
  });
};

/**
 * Converts a base64 to a file and then returns the file as formData
 * @param {ing} base64 Base 64
 * @param {*} formDataName Name for formData object
 * @param {*} fileName Name of file (excl. extension)
 */
const base64ToFormData = async (
  base64,
  fileName = "file",
  formDataName = "file"
) => {
  const block = base64.split(";");
  const contentType = block[0].split(":")[1];
  const realData = block[1].split(",")[1];
  const blob = b64toBlob(realData, contentType);
  const fileExtension = contentType.split("/")[1];

  const file = new File([blob], `${fileName}.${fileExtension}`, {
    type: contentType,
    lastModified: new Date(),
  });

  const formData = new FormData();
  formData.append(formDataName, file);
  return formData;
};

export { getFileURL, readFileAsync, base64ToFormData };
